<ng-container *ngIf="canView && clientId">
  <p-toast key="preoffer" position="top-right"></p-toast>
  <p-confirmDialog
    key="preoffer"
    [style]="{ width: '440px' }"
    acceptButtonStyleClass="p-button-sm"
    rejectButtonStyleClass="p-button-sm p-button-text"
  ></p-confirmDialog>

  <article class="alg-card po-card" [class.is-dashed]="view?.dashed" data-test="preoffer-card" aria-labelledby="po-card-title">
    <header class="alg-card__header">
      <span class="alg-card__icon"><i class="fa-solid fa-file-signature" aria-hidden="true"></i></span>
      <div class="alg-card__titles">
        <h2 id="po-card-title">Preoferta</h2>
        <p>Carta automática del cliente nuevo: lo que decidió esta calculadora y por qué</p>
      </div>
      <span class="alg-pills" *ngIf="view as v">
        <span class="alg-pill" [ngClass]="'is-' + v.tone" data-test="preoffer-state">{{ v.label }}</span>
      </span>
    </header>

    <div class="alg-card__body po-card__body">
      <p class="muted" *ngIf="state === 'loading'" aria-live="polite">Cargando la preoferta…</p>

      <p class="alg-notice is-bad" *ngIf="state === 'error'" role="alert">
        <i class="fa-solid fa-triangle-exclamation" aria-hidden="true"></i>
        <span>{{ errorMsg }}</span>
        <button type="button" class="alg-btn p-button p-button-text p-button-sm" (click)="load(true)">Reintentar</button>
      </p>

      <ng-container *ngIf="state === 'ready'">
        <p class="muted" *ngIf="!view" data-test="preoffer-empty">
          Este cliente no tiene preoferta: no es nuevo, todavía no completa su CIEC o la preoferta está apagada.
        </p>

        <ng-container *ngIf="view as v">
          <ul class="po-lines" data-test="preoffer-lines">
            <li *ngFor="let line of v.lines">{{ line }}</li>
          </ul>

          <div class="po-actions" *ngIf="(v.canDownload && canDownload) || (v.canResend && canResend)">
            <button
              *ngIf="v.canDownload && canDownload"
              pButton
              type="button"
              icon="pi pi-file-pdf"
              label="Ver PDF"
              class="p-button-outlined p-button-sm"
              [disabled]="busy"
              (click)="download()"
              data-test="preoffer-download"
            ></button>
            <button
              *ngIf="v.canResend && canResend"
              pButton
              type="button"
              icon="pi pi-send"
              label="Reenviar"
              class="p-button-sm"
              [disabled]="busy"
              (click)="resend()"
              data-test="preoffer-resend"
            ></button>
          </div>
        </ng-container>

        <details class="po-history" *ngIf="data?.history?.length">
          <summary>Evaluaciones anteriores ({{ data?.history?.length }})</summary>
          <ul>
            <li *ngFor="let item of data?.history">
              <span class="po-history__date">{{ item.createdAt | date: 'd MMM y, HH:mm' }}</span>
              <span>{{ historyView(item)?.label || item.status }}</span>
              <span class="muted" *ngIf="item.status === 'superseded'">(reemplazada)</span>
            </li>
          </ul>
        </details>
      </ng-container>
    </div>
  </article>
</ng-container>
